export const ANSWER_CHART_ID = "AnswerChartId";
